import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "../../assets/css/modal.css";
import api from "../../seller-apis/api";
import { useAlert } from "react-alert";
var timerId;
function PersonalInfoChange(props) {
  const alert = useAlert()
  const [data, setData] = useState(props.data);
  const [email, setEmail] = useState(props.data.email);
  const [phone, setPhone] = useState(props.data.phoneNumber);
  const [nPhone, setNPhone] = useState(null);
  const [cNPhone, setCNPhone] = useState(""); // Confirm new phone number
  const [nEmail, setNEmail] = useState("");
  const [cNEmail, setCNEmail] = useState("");
  const [verifyStatusEmail, setVerifyStatusEmail] = useState(false);
  const [verifyDisable, setVerifyDisable] = useState(true);
  const [verifyPhoneDisable, setVerifyPhoneDisable] = useState(true);
  const [oldemail, setOldEmail] = useState(true);
  const [oldphone, setOldPhone] = useState(true);
  const [validEmailMsg, setValidEmailMsg] = useState(null);
  const [validCEmailMsg, setValidCEmailMsg] = useState(null);
  const [validPhoneMsg, setValidPhoneMsg] = useState(null);
  const [validCPhoneMsg, setValidCPhoneMsg] = useState(null);
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOTP] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const [resendOtpDiv, setresendOtpDiv] = useState(false);
  const [timer, setTimer] = useState("00:30");
  const [oldOtp, setOldOTP] = useState(false);
  const [sendType, setSendType] = useState("");
  const [done, setDone] = useState(false);

  // sl-837 - Removed OTP medium selection, send directly to new contact


  useEffect(() => {
    setConfirmation(false);
    setEmail(props.data.email);
    setPhone(props.data.phoneNumber);
    setVerifyDisable(true);
    setVerifyPhoneDisable(true);
    setValidEmailMsg(null);
    setValidCEmailMsg(null);
    setValidPhoneMsg(null);
    setValidCPhoneMsg(null);
    setOldEmail(true);
    setOldPhone(true);
    setOldOTP(false);
    setNPhone(null);
    setCNPhone("");
    setNEmail(null);
    setCNEmail(null);
    setShowOTP(false);
    setresendOtpDiv(false);
    props.show && setDone(false);
    !props.show && startTimer(0);
    // props.show && startTimer();
  }, [props.show]);

  useEffect(() => {
    return () => clearInterval(timerId); // Clean up timer
  }, []);

  const verifyEmail = (type = "new", key = 13) => {
    if (key == 13) {
      console.log('email')
      setSendType("new");
      setVerifyStatusEmail(true);
      let param = {
        field: "email",
        email: nEmail,
        phoneType: "new"
      };

    // email  field email, email email phonetype new

    api.auth.sendOtpForSellerPersonalInfoChange(param).then((data) => {
      if (data.message && data.message.includes("email already exists")) {
        setValidEmailMsg("An account with this email already exists. Try another email ID");
        setVerifyStatusEmail(false);
      } else {
        setOTP("");
        setShowOTP(true);
        startTimer();
      }
    }).catch((error) => {
      setValidEmailMsg("An account with this email already exists. Try another email ID");
      setVerifyStatusEmail(false);
    });
  }
  };

  const verifyPhone = (type = "new",key=13) => {
    if(key==13){
    setSendType("new");
    setVerifyStatusEmail(true);
    let param = {
      field: "phoneNumber",
      phoneNumber: nPhone,
      phoneType: "new",
    };
    
    setOTP("");
    api.auth.sendOtpForSellerPersonalInfoChange(param).then((data) => {
      if (data.message && data.message.includes("phoneNumber already exists")) {
        setValidPhoneMsg("An account with this phone number already exists. Try another phone number");
        setVerifyStatusEmail(false);
      } else {
        setShowOTP(true);
        startTimer();
      }
    }).catch((error) => {
      setValidPhoneMsg("An account with this phone number already exists. Try another phone number");
      setVerifyStatusEmail(false);
    });
  }
  };

  const changePersonalInfo = (type = "new",key=13) => {
    if(key==13){
    setValidEmailMsg(null);
    setValidPhoneMsg(null);
    let param = {
      otp: otp,
      phoneType: type,
    };

    api.auth
      .changeSellerPersonalInfo(param)
      .then((data) => {
        if (data.message == "Enter Correct OTP") {
          if (props.type === "email") {
            setValidEmailMsg(data.message);
          } else {
            setValidPhoneMsg(data.message);
          }
        } else {
          if (data.message === "succesfully updated") {
            setDone(true);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
      }
  };

  const startTimer = (time=11) => {
    setresendOtpDiv(false);
    let timeLeft = time;
    setTimer(timeLeft < 10 ? `0${timeLeft}` : `${timeLeft}`); // Initialize display

    function countdown() {
      if (timeLeft <= 0) {
        clearInterval(timerId);
        setresendOtpDiv(true);
        setTimer("00");
      } else {
        timeLeft--;
        setTimer(timeLeft < 10 ? `0${timeLeft}` : `${timeLeft}`);
      }
    }

    countdown(); // call once immediately
    timerId = setInterval(countdown, 1000);
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const checkEmailChange = (email) => {
    // Clear any existing error messages when user starts typing
    setValidEmailMsg(null);
    setVerifyStatusEmail(false);
    
    if (emailRegex.test(email)) {
      if (props.data.email != email) {
        setOldEmail(true);
      } else {
        setOldEmail(false);
      }
    } else {
      setValidEmailMsg("Email is not valid");
    }
    
    // Re-validate confirm email if it has content
    if (cNEmail) {
      setTimeout(() => checkConfirmEmail(cNEmail), 0);
    }
  };
  const checkConfirmEmail = (cEmail) => {
    // Clear any existing error messages when user starts typing
    setValidCEmailMsg(null);
    
    if (emailRegex.test(cEmail) && emailRegex.test(nEmail)) {
      if (nEmail != cEmail) {
        setVerifyDisable(true);
        setValidCEmailMsg("New email and confirm email is not same");
      } else if (nEmail === cEmail && props.data.email != nEmail) {
        setVerifyDisable(false);
        setValidCEmailMsg(null);
      } else {
        setVerifyDisable(true);
      }
    } else {
      setVerifyDisable(true);
      if (cEmail && !emailRegex.test(cEmail)) {
        setValidCEmailMsg("Email is not valid");
      }
    }
  };
  const checkPhoneChange = (nphone) => {
    // Clear any existing error messages when user starts typing
    setValidPhoneMsg(null);
    setVerifyStatusEmail(false);
    
    if (nphone.length == 10) {
      if (nphone != phone) {
        setOldPhone(true);
      } else {
        setOldPhone(false);
      }
    } else {
      setValidPhoneMsg("Phone number must be 10 digits long");
    }
    
    // Re-validate confirm phone if it has content
    if (cNPhone) {
      setTimeout(() => checkConfirmPhone(cNPhone), 0);
    }
  };
  const checkConfirmPhone = (cPhone) => {
    // Clear any existing error messages when user starts typing
    setValidCPhoneMsg(null);
    
    if (cPhone.length == 10 && nPhone && nPhone.length == 10) {
      if (nPhone != cPhone) {
        setVerifyPhoneDisable(true);
        setValidCPhoneMsg("New phone and confirm phone is not same");
      } else if (nPhone === cPhone && phone != nPhone) {
        setVerifyPhoneDisable(false);
        setValidCPhoneMsg(null);
      } else {
        setVerifyPhoneDisable(true);
      }
    } else {
      setVerifyPhoneDisable(true);
      if (cPhone && cPhone.length > 0 && cPhone.length != 10) {
        setValidCPhoneMsg("Phone number must be 10 digits long");
      }
    }
  };

  // sl-837 - Removed unused styles from OTP selection UI


  // Removed OTP selection functions - now send directly to new contact

  return (
    <Modal
      show={props.show}
      onHide={props.handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="personalmodal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="header-title">
          {props.type == "email"
            ? "Change Email Address"
            : "Change Phone Number"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!done ? (
          <>
            {!confirmation ? (

              <div className="confirmation-container">
                <div className="confirmation-msg">
                  Are you sure to change your{" "}
                  {props.type == "email" ? "email ID" : "phone number"}
                </div>
                <div className="action-button">
                  <button
                    type="button"
                    className="profile-but yes-button"
                    onClick={() => {
                      setConfirmation(true);
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="profile-but no-button"
                    onClick={() => props.handleClose()}
                  >
                    No
                  </button>
                </div>
              </div>
            ) : (
              <>
                {!showOTP ? (
                  <div>
                    {props.type === "email" ? (
                      <>
                        <div className="sent-container">
                          <span>Current Email Address : </span>
                          <p>{email}</p>
                        </div>
                        <div className="sent-container profile-input-box">
                          <span>Enter New Email Address : </span>
                          <p>
                            <input
                              type="text"
                              value={nEmail}
                              onChange={(e) => {
                                setNEmail(e.target.value);
                                checkEmailChange(e.target.value);
                              }}
                              className="name-cast white-bg w-100"
                            />
                            {oldemail ? (
                              ""
                            ) : (
                              <div className="text-danger fs-10" style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
                                This email already verified
                              </div>
                            )}
                            <div className="text-danger fs-10" style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
                              {validEmailMsg ? validEmailMsg : ""}
                            </div>
                          </p>
                        </div>
                        <div className="sent-container profile-input-box">
                          <span>Re-Enter New Email Address : </span>
                          <p>
                            <input
                              type="text"
                              value={cNEmail}
                              onPaste={(e) => {
                                e.preventDefault()
                                return false;
                              }}
                              onCopy={(e) => {
                                e.preventDefault()
                                return false;
                              }}
                              onKeyUp={(e) => verifyEmail('new', e.keyCode)}
                              onChange={(e) => {
                                setCNEmail(e.target.value);
                                checkConfirmEmail(e.target.value);
                              }}
                              className="name-cast white-bg w-100"
                            />
                            <div className="text-danger fs-10" style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
                              {validCEmailMsg ? validCEmailMsg : ""}
                            </div>
                          </p>
                        </div>

                        <div className="text-center">
                          <button
                            disabled={verifyDisable}
                            onClick={() => verifyEmail('new')}
                            className="profile-but"
                          >
                            Proceed
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="sent-container">
                          <span>Current Phone Number : </span>
                          <p>{phone}</p>
                        </div>
                        <div className="sent-container profile-input-box">
                          <span>Enter New Phone Number : </span>
                          <p className="relative">
                            <label for="phone-ss" className="phonePrefix">+91 | </label>
                            <input
                              type="text"
                              inputMode="numeric"
                              pattern="\d*"
                              value={nPhone}
                              id="phone-ss"
                              onChange={(e) => {
                                //SL-812 remove all non-digit characters
                                const cleaned = e.target.value.replace(/\D/g, '').slice(0, 10);
                                setNPhone(cleaned);
                                checkPhoneChange(cleaned);
                              }}
                              className="name-cast white-bg w-100 pl-50"
                            />
                            {oldphone ? (
                              ""
                            ) : (
                              <div className="text-danger fs-10" style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
                                This Number already verified
                              </div>
                            )}
                            <div className="text-danger fs-10" style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
                              {validPhoneMsg ? validPhoneMsg : ""}
                            </div>
                          </p>
                        </div>
                        <div className="sent-container profile-input-box">
                          <span>Re-Enter New Phone Number : </span>
                          <p className="relative">
                            <label for="phone-confirm" className="phonePrefix">+91 | </label>
                            <input
                              type="text"
                              inputMode="numeric"
                              pattern="\d*"
                              value={cNPhone}
                              id="phone-confirm"
                              onPaste={(e)=>{
                                e.preventDefault()
                                return false;
                              }} 
                              onCopy={(e)=>{
                                e.preventDefault()
                                return false;
                              }}
                              onKeyUp={(e)=>verifyPhone('new',e.keyCode)}
                              onChange={(e) => {
                                //SL-812 remove all non-digit characters
                                const cleaned = e.target.value.replace(/\D/g, '').slice(0, 10); 
                                setCNPhone(cleaned);
                                checkConfirmPhone(cleaned);
                              }}
                              className="name-cast white-bg w-100 pl-50"
                            />
                            <div className="text-danger fs-10" style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
                              {validCPhoneMsg ? validCPhoneMsg : ""}
                            </div>
                          </p>
                        </div>

                        <div className="text-center">
                          <button
                            disabled={verifyPhoneDisable}
                            onClick={() => verifyPhone('new')}
                            className="profile-but"
                          >
                            Proceed
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  <div>
                    <div class="otp-title">Enter OTP</div>
                    <div className="otp-container">
                      <span>Sent to : </span>
                      <p>
                        {props.type === "email" ? nEmail : `+91 ${nPhone}`}
                      </p>
                    </div>
                    <div className="otp-container">
                      <input
                        type="text"
                        value={otp}
                        onChange={(e) => {
                          setOTP(e.target.value);
                        }}
                        onKeyUp={(e) => {
                          if (props.type == 'email') {
                            changePersonalInfo(sendType, e.keyCode)
                          }
                          else{
                            changePersonalInfo(sendType,e.keyCode)
                          }
                        }}
                        className="name-cast otp-input w-100"
                      />
                    </div>
                    <div className="text-danger fs-10" style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
                      {props.type === "email" ? (validEmailMsg ? validEmailMsg : "") : (validPhoneMsg ? validPhoneMsg : "")}
                    </div>
                    <div style={{ padding: 10, textAlign: "center" }}>
                      <div className="resend-otp text-center">
                        00:{timer}{" "}
                        {resendOtpDiv ? (
                          <strong onClick={() => {
                            if (props.type != "email") {
                              verifyPhone(sendType);
                            }
                            else {
                              verifyEmail();
                            }
                          }}>
                            Resend OTP
                          </strong>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="text-center">
                      <button
                        disabled={otp == null || otp.length != 4}
                        onClick={() => changePersonalInfo(sendType,13)}
                        class="profile-but"
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        ) : (
          <div>
            <div class="alert alert-success text-center" role="alert">
              {props.type == "email" ? "Email" : "Phone number"} successfully
              changed
            </div>
            <div className="text-center">
              <button
                class="profile-but"
                onClick={() => {
                  props.updateInfo();
                  props.handleClose();
                }}
              >
                Ok
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}
export default PersonalInfoChange;
